import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { createStructuredSelector } from 'reselect'

import Links from 'components/links/links'
import Sidebar from './sidebar/index'
import SiteEdit from './site-edit'

import withCurrentSite from 'modules/sites/containers/with-current-site'
import { SITE_PATH, SITE_EDIT_PATH } from 'config'
import { getLastSiteQueueStatus } from 'modules/queues/selectors';
import { runningStatuses } from 'modules/queues/enum';
import { LINKS_LIST_PATH } from 'config';


const Site = ({ lastQueueStatus, currentSite: site, match: { path } }) => {
  const renderActiveQueueRedirect = () => {
    if (lastQueueStatus && runningStatuses.indexOf(lastQueueStatus.status) !== -1) {
      const runningQueueLinksListPath = LINKS_LIST_PATH
        .replace(':site', site.key)
        .replace(':queue', lastQueueStatus.queueId);

      return <Redirect to={ runningQueueLinksListPath }/>
    }

    return <Links/>
  };


  return (
    <div className="site-edit">
      <div className="row">
        <div className="col-lg-3">
          <Route
            path={ `${path}/:dir?/:queueId?` }
            render={ routerProps => (<Sidebar site={ site } { ...routerProps } />) }
          />
        </div>
        <div className="col-lg-9">
          <Switch>
            <Route exact path={ SITE_EDIT_PATH } component={ SiteEdit }/>
            <Route exact path={ SITE_PATH } render={ renderActiveQueueRedirect }/>
            <Route path={ `${SITE_PATH}/:dir?/:queueId?` } component={ Links }/>
          </Switch>
        </div>
      </div>
    </div>
  )
}

Site.propTypes = {
  currentSite: PropTypes.shape({
    key: PropTypes.string,
  }),
  lastQueueStatus: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }),
  match: PropTypes.object.isRequired,
}

export default compose(
  withCurrentSite,
  connect(createStructuredSelector({ lastQueueStatus: getLastSiteQueueStatus })),
)(Site)




// WEBPACK FOOTER //
// ./src/components/sites/site.js